import React, { ReactNode, forwardRef } from 'react';
import clsx from 'clsx';
import { Modal as ModalUnstyled } from '@mui/base';
import { Button } from '../';
import './index.css';

import Backdrop from './backdrop';

export interface ModalProps {
  children: ReactNode;
  disableAutoFocus?: boolean;
  disableEnforceFocus?: boolean;
  disableEscapeKeyDown?: boolean;
  disablePortal?: boolean;
  disableRestoreFocus?: boolean;
  disableScrollLock?: boolean;
  hideBackdrop?: boolean;
  keepMounted?: boolean;
  className?: string;
  isOpen: boolean;
  title?: string | JSX.Element;
  handleClose?: () => void;
  size?: 'fullscreen' | 'small' | 'large' | 'medium';
  customRenderFooter?: ReactNode;
  isHiddenCancelButton?: boolean;
  isHiddenSaveButton?: boolean;
  cancelButtonLabel?: string;
  saveButtonLabel?: string;
  disableSaveButton?: boolean;
  handleCancel?: () => void;
  handleSave?: () => void;
  ignoreOutsideClicks?: boolean;
}

const Modal = forwardRef<HTMLInputElement, ModalProps>(function Modal(props, ref) {
  const {
    children,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = false,
    disableRestoreFocus = false,
    disableScrollLock = false,
    hideBackdrop = false,
    keepMounted = false,
    className = '',
    isOpen,
    title,
    handleClose,
    size = 'medium',
    customRenderFooter,
    isHiddenCancelButton,
    isHiddenSaveButton,
    cancelButtonLabel = 'Cancel',
    saveButtonLabel = 'Save',
    disableSaveButton = false,
    handleCancel,
    handleSave,
    ignoreOutsideClicks,
    ...other
  } = props;
  const handleCloseFunc = () => {
    handleClose && handleClose();
  };
  const handleSaveFunc = () => {
    handleSave && handleSave();
  };
  const handleCancelFunc = () => {
    handleCancel && handleCancel();
  };

  const commonProps = {
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted,
    onClose: handleCloseFunc,
    open: isOpen,
  };
  return (
    <ModalUnstyled
      className="c-modal"
      slots={{
        backdrop: Backdrop,
      }}
      ref={ref}
      {...other}
      {...commonProps}
    >
      <div className={clsx('c-modal__window', `c-modal__window--${size}`, className)}>
        {title && <div className="c-modal__title">{title}</div>}
        <div className="c-modal__close" onClick={handleCloseFunc} />
        <div className="c-modal__content">{children}</div>
        {customRenderFooter ? (
          customRenderFooter
        ) : (
          <div className="c-modal__buttons">
            {!isHiddenSaveButton && (
              <Button onClick={handleSaveFunc} className="modal-save-button" disabled={disableSaveButton}>
                {saveButtonLabel}
              </Button>
            )}
            {!isHiddenCancelButton && (
              <Button type="outline" className="modal-cancel-button" onClick={handleCancelFunc}>
                {cancelButtonLabel}
              </Button>
            )}
          </div>
        )}
      </div>
    </ModalUnstyled>
  );
});
export { Modal };
